<template>
  <div
    @click="$emit('onCreditClick',credit.youtubeURL)"
    class="credit">
    <img
      :src="`${credit.artwork}`"
      :alt="credit.artist + '-' + credit.title"
    >
    <div class="overlay">
      <div class="overlay_inner">
        <div>
          <h1 class="artist">{{ credit.artist }}</h1>
          <p class="title">{{ credit.title }}
            <!-- <small
              v-if="credit.extraDetails"
              v-text="credit.extraDetails"
            /> -->
          </p>
          <hr />
          <p class="job-role">{{ credit.jobRole }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['credit']
}
</script>

<style scoped lang="scss">
.credit {
  position: relative;
  width: 33.33vh; // Fallback for older browsers
  width: calc(var(--vh, 1vh) * 100 / 3);
  height: 33.33vh; // Fallback for older browsers
  height: calc(var(--vh, 1vh) * 100 / 3);
  color: white;

  .overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    padding: .15rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    transition: all 0.3s ease-in-out;
    background: rgba($color: #35bae5, $alpha: 0.9);
    opacity: 0;
    white-space: normal;

    @media screen and (min-width: 840px) {
      padding: 1rem;
    }

    .overlay_inner {
      position: relative;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
  }

  img {
    height: 100%;
    width: 100%;
    object-fit: cover;
  }

  &:hover {
    .overlay {
      opacity: 1;
    }
  }
  hr {
    width: 50%;
    margin: 6px auto;
    border-top: none;
    border-right: none;
    border-left: none;
    border-bottom: 1px solid;

    @media screen and (min-width: 650px) {
      margin: 18px auto;
    }
    @media screen and (max-width: 840px) and (orientation: landscape) {
      margin: 6px auto;
    }
  }
  .title,
  .job-role,
  .artist {
    font-weight: 900;
    font-size: 1rem;
    margin: 0;
    line-height: 1.3;

    @media screen and (max-width: 840px) and (orientation: landscape) {
      font-size: .7rem !important;
    }

    @media screen and (max-height: 750px) {
      font-size: .7rem !important;
    }

    @media screen and (min-width: 650px) {
      line-height: 1.5;
      font-size: 1.3rem;
    }
  }
  .title {
    font-weight: 500;
  }
}
</style>
